export default {
	name: 'customersRefund',
	data() {
		return {
			timeType: '0',
			vipLevl: '',
			CustomerID: 0,
			CustomerPhone: '',
			CustomerName: '',
			VipBeginDate: '',
			VipEndDate: '',
			VipLevlID: 1,
			Disbursements1: 0,
			Disbursements: 0,
			Deposit: 0,
			Deposit1: 0,
			CustomerState: 1,
			VipLevlIDIndex: 0,
			OperatorID: this.$store.state.user.UserID,
			clear: {},
			remarks: '',
			boxMoney: 0,
			boxMoney1: 0,
			CustomerChild: 1,
			age: 0,
			school: '',
		
			state: [{
				id: 1,
				text: '正常'
			}, {
				id: 2,
				text: '暂停'
			}, {
				id: 3,
				text: '停止'
			}]
		};
	},
	created() {
		this.clear = function() {
			this.CustomerID = 0;
			this.CustomerName = "";
			this.remarks = "";
			this.Disbursements = 0;
			this.Disbursements1 = 0;
			this.Deposit = 0;
			this.Deposit1 = 0;
			this.CustomerPhone = "";
			this.VipEndDate = "";
			this.VipEndDate = "";
			this.boxMoney = 0;
			this.boxMoney1 = 0;
			this.CustomerChild = 1;
			this.age = 0;
			this.school = "";
			this.boxMoney1 = 0;
			this.CustomerState = 1;
			
		};
		this.$request.request({
			url: 'Customer/getVipLevl',
			data: {},
			method: 'post'
		}).then(res => {
			if (res.result) {
				this.vipLevl = res.vipLevl;
			}
		});

	},
	methods: {
		editCustomer() {
			this.$request.request({
				url: 'Customer/customersRefund',
				data: {
					CustomerID: this.CustomerID,
					VipLevlID: this.VipLevlID,
					Disbursements: this.Disbursements,
					remarks: this.remarks,
					OperatorID: this.OperatorID,
					boxMoney: this.boxMoney,
					Deposit: this.Deposit,
					CustomerState: this.CustomerState
					 
				},
				method: 'post'
			}).then(res => {
				this.$uil.showMessage({
					text: res.message
				});
				this.clear();
			});
		},
		searchCustomers(e) {
			if (e.keyCode == 13 && this.CustomerPhone.length >= 11) {
				this.$request.request({
					url: 'Customer/getCustomerByCustomerCode',
					data: {
						searchText: this.CustomerPhone
					},
					method: 'post'
				}).then(res => {

					if (res.result) {
						this.CustomerState = 1;
						this.boxMoney = 0;
						this.Disbursements = 0;
						this.Deposit = 0;
						this.CustomerPhone = res.customer.CustomerPhone;
						this.CustomerName = res.customer.CustomerName;
						this.Deposit1 = res.customer.Deposit;
						this.CustomerID = res.customer.CustomerID;
						this.VipBeginDate = res.customer.VipBeginDate;
						this.VipEndDate = res.customer.VipEndDate;
						this.VipLevlID = res.customer.VipLevlID;
						this.Disbursements1 = res.customer.Disbursements;
						this.boxMoney1 = res.customer.boxMoney;
						this.age = res.customer.age;
						this.CustomerChild = res.customer.CustomerChild;
						this.school = res.customer.school;
					
					}

				});
			}
		}
	},
	computed: {
		checkDate() {
			if (this.CustomerID > 0) {
				if (this.Disbursements1 < this.Disbursements)
					return false;
				if (this.Deposit1 < this.Deposit)
					return false;
				if (this.boxMoney1 < this.boxMoney)
					return false;
				return true;
			} else
				return false;
		}
	},
	filters: {
		rmb(v) {
			return v + '¥';
		}
	}
}
